// Generate names for new colors in https://www.color-blindness.com/color-name-hue/

const LINEAR_COLORS = {
    SAVE_NEW_COMPANY: 'linear-gradient(270deg, #7BB99A 0%, #3BBBAB 100%, #3E5D4D 100%)',
    NOTIFICATION_ERROR: 'linear-gradient(90deg, #EC96E5 0%, #FB8289 100%)',
    NOTIFICATION_SUCCESS: 'linear-gradient(90deg, rgba(150,217,213,1) 0%, rgba(115,226,147,1) 69%)',
};

const TESS_COLORS = {
    ADDING: '#7bb99a',
    ADDING_LIGHT: '#e4f1eb',
    DESTRUCTIVE: '#fb8289',
    DESTRUCTIVE_LIGHT: '#fee6e7',
    FUN_BLUE: '#93BEFF',
    FUN_GRAPE_DARK: '#746191',
    FUN_GRAPE_LIGHT: '#C0A8E6',
    FUN_GREEN: '#8DD7D2',
    FUN_PINK: '#FF93B3',
    FUN_LAVANDER_DARK: '#8D90D9',
    GRAY_2: '#EBEBEB',
    GRAY_3: '#F6F6F6',
    FUN_ORANGE: '#F9B683',
    DEF_ORANGE: '#FEF3E6',
    GRAY_5: '#F1F5F9',
    GRAY_6: '#DBE2E8',
};

/**
 * @deprecated Use MainTheme of paretogroup/tess
 * import { MainTheme } from '@paretogroup/tess';
 */
export default {
    'catskill-white': '#F1F5F9',
    'cherry-pie': '#3C3655',
    'corn-flower-blue': '#42466A',
    'gray-12%': 'rgba(0,0,0,0.12)',
    'gray-20%': 'rgba(0,0,0,0.20)',
    'iris-blue': '#8b9ca6',
    'light-pink': '#FFADB2',
    'light-slate-blue': '#8573f7',
    'light-slate-gray': '#758297',
    'medium-orchid': '#CE88E5',
    'midnight-express': 'rgba(27, 22, 44, 0.2)',
    'medium-slate-blue': '#6E7DEF',
    'pastel-green': '#73E293',
    'puerto-rico': '#3BBBAB',
    'regal-blue': '#17394D',
    'regal-blue-15%': 'rgba(23,57,77,0.15)',
    'regal-blue-20%': 'rgba(23,57,77,0.2)',
    'regal-blue-50%': 'rgba(23,57,77,0.5)',
    'regal-blue-75%': 'rgba(23,57,77,0.75)',
    'regal-blue-85%': 'rgba(23,57,77,0.85)',
    'rock-blue': '#9599C1',
    'spun-pearl': '#ABA9B5',
    'summer-green': '#A2BAAE',
    'titan-white': '#D4D2DB',
    'violent-violet': '#261F41',
    'violent-violet-13%': 'rgba(38, 31, 65, 0.13)',
    'violent-violet-20%': 'rgba(38, 31, 65, 0.2)',
    'white-50%': 'rgba(255, 255, 255, 0.5)',
    'white-20%': 'rgba(255, 255, 255, 0.2)',
    'white-ice': '#d7eae0',
    'white-smoke': '#ececec',
    'bali-hai': '#8A9BA5',
    'pattens-blue': '#D0D7DB',
    'fringy-flower': '#AAE8BC',
    'default-black': '#000000',
    black: '#272727',
    'black-50%': '#888888',
    'black-25%': '#B9B9B9',
    'black-20%': '#D4D4D4',
    orchid: '#D0D7DB',
    whisper: '#EEEEEE',
    matterhorn: '#555555',
    charcoal: '#444444',
    'wild-blue-yonder': '#7386C0',
    viking: '#42a4c8',
    gainsboro: '#E8E8E8',
    grey: '#858585',
    heather: '#AEBBC4',
    manatee: '#8A8C9F',
    melrose: '#C3BDFF',
    padua: '#7BB99A',
    'padua-20%': 'rgba(123,185,154,0.2)',
    plantation: '#3E5D4D',
    salmon: '#FB8289',
    shamrock: '#3BBBAB',
    portage: '#8095D6',
    'portage-light-dark': '#8D90D9',
    sundown: '#ffadb2',
    tradewind: '#69B9A9',
    transparent: 'rgba(0, 0, 0, 0)',
    violet: '#EC96E5',
    perano: '#AAA8E1',
    wisteria: '#C0A8E6',
    riptide: '#8DD7D2',
    'jordy-blue': '#8EAFDF',
    'cape-honey': '#FDE6A2',
    'lavender-blue': '#C2BEFA',
    'light-cloud-lavender-blue': '#C7DDFF',
    'columbia-blue': '#9CC5FF',
    white: '#FFFFFF',
    zircon: '#E2E3E5',
    zumthor: '#D1D7DB',
    silver: '#B6B6B6',
    golden: '#D0C3A2',
    'we-peep': '#FEE6E7',
    'snow-white': '#F7F7F7',
    quartz: '#CCD4EF',
    'light-portage': '#99AADE',
    'light-perano': '#B3BFE6',
    'white-lilac': '#EBEEF8',
    'black-squeeze': '#f6f9fc',
    'tropical-blue': '#B7C7F8',
    fiord: '#4E5664',
    error: '#e2445c',
    GRAY_SUIT: '#8f8c9d',
    LINEAR_COLORS,
    DISABLED_FIELD_BG: '#E2E3E5',
    DISABLED_FIELD_COLOR: '#17394D33',
    ERROR_FIELD_BORDER: '#FB8289',
    ERROR_FIELD_COLOR: '#FB8289',
    'time-warning-red': '#FEF3E6',
    tower_gray: '#AFBABF',
    ...TESS_COLORS,
};
